// extracted by mini-css-extract-plugin
export default {"Button":"Button_Button__tnlho","ButtonIcon":"Button_ButtonIcon__GYxsv"};